import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { BOOKING_THEME } from '../bookingTheme';

interface BookingNavFooterProps {
  backLabel: string;
  onBack: () => void;
  backDisabled?: boolean;
  nextLabel?: string;
  onNext?: () => void;
  nextDisabled?: boolean;
  nextHint?: string;
  showNext?: boolean;
}

const BookingNavFooter: React.FC<BookingNavFooterProps> = ({
  backLabel,
  onBack,
  backDisabled = false,
  nextLabel = 'Next',
  onNext,
  nextDisabled = false,
  nextHint,
  showNext = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={onBack}
      disabled={backDisabled}
      sx={{ color: BOOKING_THEME.textSecondary, textTransform: 'none' }}
    >
      {backLabel}
    </Button>

    {showNext && onNext ? (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={onNext}
          disabled={nextDisabled}
          sx={{
            bgcolor: BOOKING_THEME.stepperActive,
            color: '#fff',
            '&:hover': { bgcolor: '#222' },
            borderRadius: 2,
            px: 3,
            '&.Mui-disabled': { bgcolor: '#ccc', color: '#888' },
          }}
        >
          {nextLabel}
        </Button>
        {nextHint && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
            {nextHint}
          </Typography>
        )}
      </Box>
    ) : (
      <Box sx={{ width: 1 }} />
    )}
  </Box>
);

export default BookingNavFooter;
